import { onError } from '@apollo/client/link/error';
import { isAccessClaimsError } from './accessClaims';

/**
 * Apollo link that calls `onAccessError` when Hasura rejects the session's JWT claims. It passes every
 * result and error through unchanged.
 *
 * Place it after any link whose request handler is async (App.js's `authMiddleware`). Such a link returns
 * a Promise instead of an Observable, and `onError` subscribes to its `forward()` synchronously, so
 * putting this link in front of one fails every operation.
 * @param {() => void} onAccessError Called once per failed operation.
 * @returns {import('@apollo/client').ApolloLink}
 */
export const createAccessErrorLink = (onAccessError) =>
    onError(({ graphQLErrors, networkError }) => {
        if (isAccessClaimsError({ graphQLErrors, networkError })) onAccessError();
    });
